import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  CookieHelperService,
  UserSessionService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AccountManagementService {
  isBusiness = false;
  displayBusinessTypeSection = false;

  private cookieHelper = inject(CookieHelperService);
  private userSession = inject(UserSessionService);

  checkForAccountType(destroyRef: DestroyRef): void {
    this.userSession
      .getUserSession()
      .pipe(
        takeUntilDestroyed(destroyRef),
        tap((res) => this.setBusinessCookieIfNeeded(res))
      )
      .subscribe(() => {
        this.readAccountCookie();
      });
  }

  private setBusinessCookieIfNeeded(res: {
    crprtName?: string;
    firstName?: string;
  }): void {
    if (!res.crprtName) return;

    const accountCookiePresent = this.cookieHelper.getAccountCookie('account');
    if (accountCookiePresent) return;

    const cookieDomain = this.cookieHelper.defaultCookieDomain();

    const personalAccount = {
      isBusiness: false,
      name: encodeURIComponent(res.firstName?.toString() || ''),
      businessAccountOptionsList: {
        isOaSmeAccount: false,
        partnerId: 'personal',
        accoutnIndex: 0,
        restrictPaxToOne: false,
        displayInLineText: ''
      }
    };
    this.cookieHelper.setCookieName(
      'account',
      JSON.stringify(personalAccount),
      0,
      true,
      '/',
      cookieDomain
    );
  }

  private readAccountCookie(): void {
    const account = this.cookieHelper.getAccountCookie('account');
    if (account && account.length) {
      const parseAccount = JSON.parse(account);
      this.displayBusinessTypeSection = true;
      this.isBusiness = parseAccount['isBusiness'];
    }
  }
}
